<div class="outerContainer"style="position: relative;">   
    <div [ngClass]="{'show': count < 20}" class="forward" (click)="scrollRight()"> &gt; </div>      
    <div [ngClass]="{'show': count > 5}" class="backward" (click)="scrollLeft()"> &lt; </div>
    <div class="responsive" id="flatLessonContainer" >
        <div  *ngFor="let lesson of lessonCards" class="gallery">
            <div [attr.id]=lessonIDs[lesson.id-1] class="lessonContainer" (click)="chooseLesson(lesson)" tabindex="0">
                <img alt="lesson tile image" src={{lesson.img}} class="lessonPhoto">
                <div class=" lessonIndex "><span class="greyText captionText">{{config?.guide}} {{lesson.id}}</span></div>
                <div class=" lessonTitle "><span class="darkGreyText regularText">{{lesson.title}}</span></div>
            </div>
        </div>
    </div>
</div>